<template>
  <div class="condition">
    <form @submit.prevent>
      <div class="form-group" v-if="campaignItem">
        <span v-if="campaignItem.time_rule.choice === 'both'">
          The contact's last visit or purchase was exactly <input type="number" v-model="relative_days" class="form-control" /> days ago.
        </span>
        <span v-if="campaignItem.time_rule.choice === 'behavior'">
          The contact's last visit or purchase was exactly <input type="number" v-model="relative_days" class="form-control" /> days ago.
        </span>
      </div>
      <div class="form-group" v-else>
        Any contact whose last interaction was exactly <input type="number" v-model="relative_days" class="form-control" /> days ago.
      </div>
      <button class="xpl-button xpl-button--primary" @click.stop="commitCondition">Save</button>
    </form>
  </div>
</template>
<script>
  import EventBus from '@/event-bus';

  export default {
    props: ['uuid', 'rule', 'campaignItem'],
    data() {
      return {
        relative_days: 30,
      };
    },
    created() {
      if (this.rule && this.rule.length && this.rule[0].relative_days) {
        this.relative_days = this.rule[0].relative_days;
      }
    },
    methods: {
      commitCondition(event) {
        const target = event.target || event.srcElement;
        target.disabled = true;
        target.innerHTML = '<i class="fa fa-spin fa-spinner fa-fw"></i>';

        const payload = {
          condition: {
            uuid: this.uuid,
            quick: true,
          },
          last_visit_type: 'both',
          relative_days: this.relative_days,
          comparison: 'exactly',
          misc: {
            filtering: false,
          },
        };
        EventBus.$emit('condition.commit', payload);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .form-group {
    display: flex;
    align-items: center;
  }

  .form-group span {
    display: flex;
    align-items: center;
  }

  .form-group input {
    width: auto;
    margin-left: .5rem;
    margin-right: .5rem;
  }

  .btn-bb-primary {
    margin-top: 1.5rem;
  }
</style>
